import classnames from 'classnames/bind';
import style from './index.module.scss';
import Common from '../../Common/Common';
import CommonPop from '../CommonPop';
import { DiscountCfg } from '../../Common/ShopCardData';

const className = classnames.bind(style);
const DiscountPop = ()=>{
  const CommonData = Common.Common;
  const closeFunc = ()=>{
    CommonData.ShowReward = false;
  }
  return(
    <CommonPop titlestr='Up to 25% off' closeWindown={closeFunc}>
    <div className={className('frame')}>
        {DiscountCfg.map((value,index)=>{
            return(
                <div className={className('itemobj')} key={"r"+index}>
                  Buy&nbsp;
                  <div className={className('discount')}>{value[0]}</div>&nbsp;
                  or more items and get a&nbsp;
                  <div className={className('discount')}>{`${value[1]}%`}</div>&nbsp;
                  discount
                </div>
            )
        })}
    </div>
    </CommonPop>
  )
}

export default DiscountPop;